import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';

export default function Header() {
  const notificationData = [
    {
      day: 'today',
      notifications: [
        {
          img: '/assets/imgs/notification_1.png',
          title: 'New Booking',
          descp:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          time_ago: '2min ago',
        },
        {
          img: '/assets/imgs/notification_2.png',
          title: 'New Booking',
          descp:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          time_ago: '2min ago',
        },
        {
          img: '/assets/imgs/notification_3.png',
          title: 'New Booking',
          descp:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          time_ago: '2min ago',
        },
      ],
    },
    {
      day: 'Yesterday',
      notifications: [
        {
          img: '/assets/imgs/profile.png',
          title: 'New User',
          descp:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          time_ago: '2min ago',
        },
        {
          img: '/assets/imgs/profile.png',
          title: 'New User',
          descp:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
          time_ago: '2min ago',
        },
      ],
    },
  ];

  const [showNotification, setShowNotification] = useState(false);
  return (
    <div className='header'>
      <div
        style={{ display: showNotification ? '' : 'none' }}
        onClick={() => setShowNotification(!showNotification)}
        className='notification_popup_BG'
      ></div>
      <div className='search'>
        <input type='text' name='search' id='search' placeholder='Search' />
        <svg viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M11.7932 3.64724C13.3576 3.64581 14.8873 4.10841 16.1888 4.97652C17.4903 5.84463 18.505 7.07925 19.1047 8.52418C19.7044 9.96911 19.862 11.5594 19.5577 13.094C19.2533 14.6285 18.5007 16.0383 17.395 17.1451C16.2893 18.2518 14.8802 19.0057 13.3459 19.3114C11.8116 19.6172 10.2212 19.461 8.7757 18.8626C7.33022 18.2643 6.09468 17.2506 5.22538 15.95C4.35608 14.6493 3.89208 13.12 3.89208 11.5556C3.90156 9.46233 4.73682 7.45741 6.21631 5.97657C7.6958 4.49572 9.69995 3.65864 11.7932 3.64724ZM11.7932 2.16669C9.93624 2.16669 8.121 2.71734 6.577 3.749C5.03301 4.78066 3.82961 6.24701 3.11899 7.9626C2.40837 9.6782 2.22243 11.566 2.58471 13.3873C2.94698 15.2085 3.84118 16.8815 5.15424 18.1945C6.4673 19.5076 8.14024 20.4018 9.96151 20.7641C11.7828 21.1263 13.6706 20.9404 15.3862 20.2298C17.1018 19.5192 18.5681 18.3158 19.5998 16.7718C20.6314 15.2278 21.1821 13.4125 21.1821 11.5556C21.1821 9.06549 20.1929 6.67739 18.4321 4.91663C16.6714 3.15587 14.2833 2.16669 11.7932 2.16669Z'
            fill='#4FC8E9'
          />
          <path
            d='M25.278 24.0428L19.9552 18.6839L18.9297 19.7022L24.2525 25.0611C24.3193 25.1285 24.3988 25.182 24.4863 25.2186C24.5739 25.2552 24.6678 25.2742 24.7627 25.2746C24.8576 25.2749 24.9516 25.2566 25.0394 25.2205C25.1272 25.1845 25.2071 25.1316 25.2744 25.0647C25.3417 24.9979 25.3953 24.9184 25.4319 24.8308C25.4685 24.7433 25.4875 24.6494 25.4879 24.5545C25.4882 24.4596 25.4698 24.3656 25.4338 24.2778C25.3978 24.19 25.3449 24.1101 25.278 24.0428Z'
            fill='#4FC8E9'
          />
        </svg>
      </div>
      <div className='header_btns'>
        <div className='notification header_btn'>
          <svg
            onClick={() => setShowNotification(!showNotification)}
            width='26'
            height='26'
            viewBox='0 0 26 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g opacity='0.8'>
              <path
                d='M21.9593 12.6158C21.1679 11.6917 20.8083 10.8908 20.8083 9.53027V9.06766C20.8083 7.29468 20.4002 6.15234 19.5131 5.01C18.1457 3.23593 15.8437 2.16669 13.5902 2.16669H13.4944C11.2883 2.16669 9.05847 3.18683 7.6674 4.88889C6.73176 6.05415 6.27632 7.24559 6.27632 9.06766V9.53027C6.27632 10.8908 5.9404 11.6917 5.12535 12.6158C4.52563 13.2966 4.33398 14.1717 4.33398 15.1187C4.33398 16.0668 4.64515 16.9648 5.26962 17.6947C6.08467 18.5697 7.23565 19.1284 8.41138 19.2255C10.1136 19.4197 11.8159 19.4928 13.5429 19.4928C15.2688 19.4928 16.971 19.3706 18.6743 19.2255C19.849 19.1284 21 18.5697 21.815 17.6947C22.4384 16.9648 22.7507 16.0668 22.7507 15.1187C22.7507 14.1717 22.559 13.2966 21.9593 12.6158Z'
                fill='#4FC8E9'
              />
              <path
                d='M15.7179 20.8308C15.1763 20.7151 11.8763 20.7151 11.3347 20.8308C10.8718 20.9377 10.3711 21.1864 10.3711 21.732C10.398 22.2524 10.7027 22.7118 11.1248 23.0031L11.1237 23.0042C11.6696 23.4297 12.3102 23.7003 12.981 23.7974C13.3384 23.8465 13.7024 23.8443 14.0727 23.7974C14.7424 23.7003 15.3831 23.4297 15.9289 23.0042L15.9279 23.0031C16.3499 22.7118 16.6546 22.2524 16.6815 21.732C16.6815 21.1864 16.1809 20.9377 15.7179 20.8308Z'
                fill='#4FC8E9'
              />
            </g>
          </svg>
          <div
            className='notification_popup'
            style={{ display: showNotification ? '' : 'none' }}
          >
            <h6>Notification</h6>
            <div className='notification_subheader'>
              <span>All</span>
              <span>Mark as all read</span>
            </div>
            {notificationData.map((notifications) => (
              <>
                <div className='day'>{notifications.day}</div>
                {notifications.notifications.map((notification) => (
                  <div className='day_row'>
                    <div className='img'>
                      <img src={notification.img} alt={notification.title} />
                    </div>
                    <div className='body'>
                      <div className='title'>
                        <span>{notification.title}</span>
                        <span>{notification.time_ago}</span>
                      </div>
                      <div className='descp'>{notification.descp}</div>
                    </div>
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>
        <Link to='/settings' className='setting header_btn'>
          <svg
            width='26'
            height='26'
            viewBox='0 0 26 26'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M14.971 23.8334H11.0277C10.7806 23.8334 10.5409 23.749 10.3484 23.5941C10.1559 23.4392 10.0221 23.2232 9.96926 22.9819L9.52835 20.9409C8.94016 20.6831 8.38243 20.3608 7.86543 19.9799L5.87535 20.6137C5.63979 20.6888 5.38562 20.6811 5.15506 20.5918C4.92449 20.5025 4.7314 20.3371 4.60785 20.1229L2.63185 16.7094C2.50959 16.495 2.46369 16.2455 2.50167 16.0017C2.53966 15.7578 2.65926 15.5341 2.84093 15.3671L4.38468 13.9588C4.31448 13.3208 4.31448 12.6771 4.38468 12.0391L2.84093 10.634C2.65901 10.4669 2.53924 10.243 2.50125 9.99895C2.46326 9.75489 2.50931 9.50515 2.63185 9.29069L4.60351 5.87494C4.72707 5.66078 4.92016 5.49533 5.15073 5.40606C5.38129 5.31679 5.63546 5.30907 5.87101 5.38419L7.8611 6.01794C8.12543 5.82294 8.4006 5.64094 8.68443 5.47627C8.95851 5.32244 9.24018 5.18269 9.52835 5.0581L9.97035 3.01927C10.023 2.7779 10.1565 2.56177 10.3488 2.4067C10.5411 2.25163 10.7806 2.16695 11.0277 2.16669H14.971C15.2181 2.16695 15.4576 2.25163 15.6499 2.4067C15.8422 2.56177 15.9757 2.7779 16.0283 3.01927L16.4747 5.05919C17.0621 5.31839 17.6197 5.64059 18.1376 6.0201L20.1288 5.38635C20.3642 5.31151 20.6181 5.31937 20.8484 5.40863C21.0788 5.49788 21.2717 5.66318 21.3952 5.8771L23.3668 9.29285C23.6182 9.73377 23.5315 10.2917 23.1578 10.6351L21.614 12.0434C21.6842 12.6814 21.6842 13.3251 21.614 13.9631L23.1578 15.3714C23.5315 15.7159 23.6182 16.2728 23.3668 16.7137L21.3952 20.1294C21.2716 20.3436 21.0785 20.509 20.848 20.5983C20.6174 20.6876 20.3632 20.6953 20.1277 20.6202L18.1376 19.9864C17.621 20.3671 17.0636 20.689 16.4758 20.9463L16.0283 22.9819C15.9755 23.223 15.8419 23.4389 15.6496 23.5938C15.4573 23.7486 15.2179 23.8331 14.971 23.8334ZM12.995 8.66669C11.8457 8.66669 10.7435 9.12323 9.93088 9.93589C9.11823 10.7485 8.66168 11.8507 8.66168 13C8.66168 14.1493 9.11823 15.2515 9.93088 16.0642C10.7435 16.8768 11.8457 17.3334 12.995 17.3334C14.1443 17.3334 15.2465 16.8768 16.0591 16.0642C16.8718 15.2515 17.3283 14.1493 17.3283 13C17.3283 11.8507 16.8718 10.7485 16.0591 9.93589C15.2465 9.12323 14.1443 8.66669 12.995 8.66669Z'
              fill='#4FC8E9'
            />
          </svg>
        </Link>
        <div className='profile_section'>
          <div className='profile_img'>
            <img src='/assets/imgs/profile.jpg' alt='profile' />
          </div>
          Julia Anderson
        </div>
      </div>
    </div>
  );
}
